import { isPlatformBrowser } from '@angular/common';

let id: string;

function l() {
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.src = `https://widget.intercom.io/widget/${id}`;
  var x = document.getElementsByTagName('script')[0];
  x.parentNode.insertBefore(s, x);
}

export function loadIntercom(appId: any, platformId: object, callback?: (ev: Event) => any) {
  if (isPlatformBrowser(platformId)) {
    // TODO: This could probably be removed
    (<any>window).Intercom = intercomBootstrap();
    createScript(appId, callback);
  }
}

function createScript(appId: string, callback?: (ev: Event) => any) {
  if (appId === 'null' || !appId) {
    return;
  }
  var scriptTag: any = document.createElement('script');
  scriptTag.type = 'text/javascript';
  scriptTag.async = true;
  scriptTag.src = `https://widget.intercom.io/widget/${appId}`;

  if (scriptTag.attachEvent) {
    scriptTag.attachEvent('onload', callback);
  } else {
    scriptTag.addEventListener('load', callback, false);
  }

  var s = document.getElementsByTagName('head')[0];
  s.appendChild(scriptTag);
}

function intercomBootstrap() {
  let Intercom: any = function () {
    Intercom.c(arguments);
  };
  Intercom.q = [];
  Intercom.c = function (args: any) {
    Intercom.q.push(args);
  };
  return Intercom;
}
